const MMS = () => {
    return (
       
        <div>
            <div className="">
                <img src="/ExpressBanner/banner-8.jpg" width="100%"/>
            </div>
            <div className="flex flex-col justify-center items-center mb-[1.5rem]">
                <hr className="w-[52rem]"/>
                <div className="lg:flex md:grid flex-1 justify-center items-start mx-auto max-w-[60rem] my-[5rem] gap-5 ">
        
                    <div className="flex flex-col justify-center">
                        <h1 className="font-bold text-3xl text-[#373737]">
                            MMS
                        </h1>
                        <p className="text-sm text-md  lg:max-w-[25rem] md:w-[30rem] mt-[1rem]">
                            TCS is proud to be Pakistan’s fastest digital transactional printing facility, offering an end-to-end
                            mail management solution (MMS) and managed print solutions (MPS). Covering all aspects of print and 
                            bulk distribution, including designing and variable data printing and auto-duplexing.
                        </p>
                        <p className="text-sm text-md  lg:max-w-[25rem] md:w-[30rem] mt-[1rem]">
                            Having one facility in Karachi and the other in Lahore, and a capacity to print more than 2 million 
                            impressions and 600,000 stuffing of envelopes per day TCS print shop facility in Karachi is ISO 
                            9001:2008 and ISO 27001:2005 certified and the TCS Printshop facility in Lahore is ISO 9001:2008 
                            certified.
                        </p>
                        <p className="text-sm text-md  lg:max-w-[25rem] md:w-[30rem] mt-[1rem]">
                            The bulk delivery and mail room management services that TCS provides to some of the nationwide 
                            leading banks, telecom, insurance and education companies include: printing, stuffing, procurement, 
                            mail room management service, normal bulk shipment distribution, confirmation circulars delivery 
                            service, CNIC expiry info circular, debit/credit card and CNIC delivery services.
                        </p>
                    </div>
                    <div className="flex-1 flex flex-col justify-center items-center">
                        <img src="/Home/trainingdevelop/traning-1.jpg" alt="" className="max-w-[45rem] h-[30vh]"/>
                    </div>
                </div>
      
            </div>
        </div>
        
    )
};
export default MMS;